import { supabase } from './supabase';

// Boundary scraped_date across a set of stores — one tight
// (store_id, scraped_date) index descent per store, in parallel, combined
// client-side. The single-query form (`.in(storeIds)` + ORDER BY
// scraped_date LIMIT 1) looks cheaper but makes the planner walk a
// PK/date-ordered index filtering by store: measured 3.4s on a cold cache
// (2026-07-07) and over the statement timeout under load — the same trap
// as the sales tab's full-day fetch. Per-store probes are immune to cache
// state (~2 page reads each).
export async function boundaryDateAcross(storeIds, { lte = null, ascending = false } = {}) {
  const results = await Promise.all(storeIds.map(id => {
    let q = supabase
      .from('price_history').select('scraped_date')
      .eq('store_id', id)
      .not('scraped_date', 'is', null);
    if (lte) q = q.lte('scraped_date', lte);
    return q.order('scraped_date', { ascending }).limit(1).maybeSingle();
  }));
  let best = null;
  for (const r of results) {
    if (r.error) throw r.error;
    const d = r.data?.scraped_date;
    if (d && (!best || (ascending ? d < best : d > best))) best = d;
  }
  return best;
}
